import { Button, Modal } from "react-bootstrap";
import { PiSealWarningFill } from "react-icons/pi";
import { MdCheckCircle } from "react-icons/md";


// OLD CODE - Confirmation before submit
// function ConfirmationModal({ show, onClose, onConfirm }) {
//     return (
//         <Modal show={show} onHide={onClose} centered>
//             <Modal.Body className="d-flex flex-column align-items-center gap-3">
//                 <div className="d-flex align-items-center gap-2 text-warning" style={{ fontSize: 40 }}>
//                     <PiSealWarningFill />
//                 </div>
//                 <div className="d-flex flex-column text-danger text-center">
//                     <span>Are you sure you want to submit?</span>
//                     <span>Once submitted, you won't be able to edit your answers.</span>
//                 </div>
//                 <div className="d-flex justify-content-center gap-2 w-100">
//                     <Button variant="light" style={{ border: '1px solid #ced4da' }} onClick={onClose}>
//                         Cancel
//                     </Button>
//                     <Button variant="warning" onClick={onConfirm}>
//                         Submit
//                     </Button>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// }

// NEW CODE - Success message after submit
function ConfirmationModal({ show, onConfirm, message }) {
    return (
        <Modal
            show={show}
            onHide={() => {}}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body className="d-flex flex-column align-items-center gap-3">
                <div className="d-flex align-items-center gap-2" style={{ fontSize: 40, color: '#0066CC' }}>
                    <MdCheckCircle />
                </div>
                <div className="d-flex flex-column text-center">
                    <span style={{ fontSize: '18px', fontWeight: '500' }}>
                        {message || "Your Response Has Been Submitted"}
                    </span>
                </div>
                <div className="d-flex justify-content-center gap-2 w-100">
                    <Button
                        variant="primary"
                        onClick={onConfirm}
                        style={{ minWidth: '100px', backgroundColor: '#0066CC', borderColor: '#0066CC' }}
                    >
                        OK
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ConfirmationModal;